import { z } from "zod";

export const JobPayloadSchema = z.object({
  userId: z.string(),
  jobId: z.string(),
  status: z.union([
    z.literal("queued"),
    z.literal("processing"),
    z.literal("completed"),
    z.literal("failed"),
  ]),
  timestamp: z.number(),
  payload: z.object({
    current: z.number().optional(),
    total: z.number().optional(),
    message: z.string().optional(),
    result: z.unknown().optional(),
  }),
});
